import { render, staticRenderFns } from "./SonsMergeCard.vue?vue&type=template&id=451c1f19&scoped=true&"
import script from "./SonsMergeCard.vue?vue&type=script&lang=js&"
export * from "./SonsMergeCard.vue?vue&type=script&lang=js&"
import style0 from "./SonsMergeCard.vue?vue&type=style&index=0&id=451c1f19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451c1f19",
  null
  
)

export default component.exports